<script>
  import { Slider, isDev } from '$client';
  import Item from './Item.svelte';
  export let data = [];
  export let type = 'white';
  export let header = 'Услуги';
  export let buttons = true;
  export let url = '';

  const media = [
    //? Медиа запросы
    // экран / gap / кол. элементов слайдера
    { size: 99999, gap: 30, count: 4 },
    { size: 1500, gap: 30, count: 4 },
    { size: 1199.98, gap: 20, count: 3 },
    { size: 991.98, gap: 15, count: 3 },
    { size: 767.98, gap: 10, count: 2 },
    { size: 575, gap: 10, count: 1 },
  ];
</script>

<Slider
  {buttons}
  {url}
  attributes={{ 'data-class': 'services-slider' }}
  {header}
  {type}
  component={Item}
  {data}
  {media} />
